import { useMemo } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import useAuth from "../../shared/hooks/useAuth";
import CustomSpinner from "../../shared/components/customSpinner/customSpinner";
import { PAGES_URL } from "../../shared/constants/constants";

const PrivateRoutes = () => {
  const loggedIn = useAuth(true); // Use stable value instead of Math.random()
  const location = useLocation();
  console.log("PrivateRoutes - loggedIn:", loggedIn, "location:", location.pathname);
  if (loggedIn === undefined) {
    return <CustomSpinner />;
  }

  if (loggedIn === false) {
    // If auth is false, redirect to the signin page
    return <Navigate to={PAGES_URL.SIGN_IN} />;
  }

  if (location.pathname === "/") {
    // If the current location is '/', redirect to the dashboard
    return <Navigate to={PAGES_URL.HOME} />;
  }

  // Otherwise, render the child routes
  return <Outlet />;
};

export default PrivateRoutes;
